import type { ComponentProps } from "react";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import { SectionLabel } from "../../../../../components/primitives/data-display/SectionLabel";
import { gaps } from "../../../../../components/primitives/spacing";
import { Panel } from "../../../../../components/primitives/surfaces/Panel";
import { FeedCompositionWithSubjectNames } from "./FeedCompositionWithSubjectNames";
import { FeedOutcomes } from "./FeedOutcomes";

type OutcomesProps = ComponentProps<typeof FeedOutcomes>;
type CompositionProps = ComponentProps<typeof FeedCompositionWithSubjectNames>;

interface FeedPapersProps extends OutcomesProps {
  composition: CompositionProps["composition"];
  tab: CompositionProps["tab"];
  onTabChange: CompositionProps["onTabChange"];
}

/** The papers a feed returned, in one panel: what became of them and, of those in the corpus, what
 *  they are made of. A feed that has returned none has no composition to show. */
export function FeedPapers({
  statistics,
  unavailable,
  composition,
  tab,
  onTabChange,
}: FeedPapersProps) {
  const returnedNothing = statistics?.returnedCount === 0;

  return (
    <Panel fill>
      <Stack gap={gaps.base}>
        <FeedOutcomes statistics={statistics} unavailable={unavailable} />
        {returnedNothing ? null : (
          <>
            <Divider />
            <Stack gap={gaps.snug}>
              <SectionLabel>Papers in the corpus</SectionLabel>
              <FeedCompositionWithSubjectNames
                composition={composition}
                tab={tab}
                onTabChange={onTabChange}
              />
            </Stack>
          </>
        )}
      </Stack>
    </Panel>
  );
}
